<div class="component-container">
  <div class="claim-count text-type-15">Open Claims</div>
  <div class="claim-summary">
    <div class="open-claims">
      <mat-icon class="open-claims-icon" svgIcon="open-issues"/>
      <div class="details-section" (click)="redirectToProjectClaims()">
        <div class="label text-type-8">{{ data?.open_claims_count || 0 }} open</div>
        <div class="sub-label text-type-14">({{ data?.open_claims_today || 0 }} today)</div>
      </div>
    </div>
    <div class="closed-claims">
      <mat-icon class="closed-claims-icon" svgIcon="closed-issues"/>
      <div class="details-section" (click)="redirectToProjectClaims()">
        <div class="label text-type-8">{{ data?.closed_claims_count || 0 }} closed</div>
        <div class="sub-label text-type-14">({{ data?.closed_claims_today || 0 }} today)</div>
      </div>
    </div>
  </div>
</div>
